/*******************************************************************************
TRIGGER COMMENT REPLY
Trigger moving the form after the selected comment
*******************************************************************************/

export default async function triggerCommentReply(e) {
    const $replyButton = $(e.currentTarget);

    // Get the parent comment, the following comment ad our target form
    const $comment = $replyButton.parents('.article-comment');
    const $nextComment = $comment.nextAll('.article-comment:not(.is-reply):first');
    const $commentList = $comment.parents('.article-comments__list');
    const $form = $('#articleComments');

    // Setup the form
    const commentID = $comment.data('id');
    $form.find('textarea').val('');
    $form.find('input[name="parentComment"]').val(commentID);

    // Change the button text to a reply message
    const $submitButton = $form.find('.submit-reply-form');
    const buttonHTML = $submitButton.html();
    const buttonText = $submitButton.clone().find('>*').remove().end().html();    // eslint-disable-line newline-per-chained-call
    const newButtonHTML = buttonHTML.replace(buttonText, 'Add Your Reply');

    // Set a data attribute with the original button html
    $submitButton.data('origbuttonhtml', buttonHTML);

    // Set the button HTML
    $submitButton.safehtml(newButtonHTML);

    // Show the cancel button
    const $cancelButton = $form.find('.hide-reply-form');
    $cancelButton.show();

    if($nextComment.length){
        $form.detach().insertBefore($nextComment);
    } else {
        $form.detach().appendTo($commentList);
    }

    // Make sure the user can see the form
    $('html, body').animate({ scrollTop: $('#articleComments').offset().top }, 300);

}
